import { useEffect } from 'react'

import { getRouteApi, notFound } from '@tanstack/react-router'
import { CircularProgress } from 'ui/components'

import { useGetContactDetails } from '../../hooks/useGetContactDetails'
import { ContactDetailsPage } from './components'

const ContactDetails = () => {
  const contactId = getRouteApi('/_app/contacts/$contactId').useParams({ select: (s) => Number(s.contactId) })

  const { isFetched, isFetching, data, refetch, historyTableConfig, documentsTableConfig } =
    useGetContactDetails(contactId)

  useEffect(() => {
    if ((isFetched && !data) || contactId === 0 || isNaN(contactId)) {
      throw notFound()
    }
  }, [data, isFetched, contactId])

  if (isFetching && !data) {
    return <CircularProgress centered />
  }

  if (!data) {
    return null
  }

  return (
    <ContactDetailsPage
      isFetching={isFetching}
      data={data}
      invalidate={refetch}
      historyTableConfig={historyTableConfig}
      documentsTableConfig={documentsTableConfig}
    />
  )
}

export default ContactDetails
